import { Add } from '@mui/icons-material';
import { IconTypography } from '@procureai/ui-mui';

import { SupplierOptionProps } from '../../SupplierContactAutocomplete.types.ts';

import { Root } from './SupplierAddOption.styled.ts';

export const SupplierAddOption = ({ data, onSecondaryActionClick, ...props }: SupplierOptionProps) => {
  return (
    <Root {...props} onClick={onSecondaryActionClick}>
      <IconTypography component="div" variant="subtitle2" color="text.primary" display="block" startIcon={<Add />}>
        {data.value}
      </IconTypography>
    </Root>
  );
};
